(function () {
    'use strict';

    angular.module("imApp").factory("shiftPlanService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 513,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 514,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 515,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
